import template from './paginationRemote.html';
import controller from './paginationRemote.controller';

const paginationRemoteComponent = {
  restrict: 'E',
  bindings: {
      pageChangedButtonPressed: '=',
      setPagesNumber: '=',
      setCurrentPageIndex: '='

  },
  template,
  controller
};

export default paginationRemoteComponent;



/** WEBPACK FOOTER **
 ** ./client/app/common/components/pagination-remote/paginationRemote.component.js
 **/